import { CAMERA_PRESENTER } from '@shoflo/polymer/constants/SourceItems';
import {
  SOURCE_ROLE_SPEAKER,
  SOURCE_ROLE_HOST
} from '@shoflo/polymer/constants/SourceRoleTypes';
import { UNASSIGNED } from '@studio/constants/Sources';

export function getSpeakerSources(sources) {
  return sources.filter(
    source =>
      source.role === SOURCE_ROLE_SPEAKER &&
      'user' in source &&
      source.type === CAMERA_PRESENTER &&
      source.value !== UNASSIGNED
  );
}

export function getHostSources(sources) {
  return sources.filter(
    source =>
      source.role === SOURCE_ROLE_HOST &&
      'user' in source &&
      source.type === CAMERA_PRESENTER &&
      source.value !== UNASSIGNED
  );
}
